<template>
  <div v-if="demande">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('editionIntervention.infoGenerale.addPatToDemande.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{$t('general.button.return')}}
              </button>
              <button class="button is-addOrEdit mgl-10px" @click="selectPatrimoine()">
                {{$t('general.button.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form class="column is-12 pdr-0" @submit.prevent="loadEmplacement(getPageRecherche)">
            <b-input :placeholder="$t('general.button.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='showFiltre = !showFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}</span>
            </button>
            <div class="info-circle-right background-primary is-pulled-right"
                 v-if="getFilteredNumber > 0">
              <span class="inside-circle">{{ getFilteredNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px" v-if="startArrayRendering">
      <emplacementDispositifMaterielFacePicker @change="loadEmplacement"
                                               @passToFalse="passToFalse"
                                               :selectOnlyOneObject="true"
                                               :displayHeader="false"
                                               :dateDebut="demande.datePlanification
                                               ? demande.datePlanification : new Date()"
                                               :dateFin="demande.datePlanification
                                                 ? demande.datePlanification : new Date()"
                                               :emplacements="emplacements"
                                               :total="total">
      </emplacementDispositifMaterielFacePicker>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showFiltre">
        <filtre-emplacement v-if="showFiltre" @toggleFiltre="showFiltre = !showFiltre"
                            @recherche="closeFiltreAndMakeRecherche"
                            :critereRecherche="critereRecherche"/>
      </div>
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRechercheEmplacement
  from '@/services/gabed/emplacement/generer/genererCritereRechercheEmplacement';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import emplacementDispositifMaterielFacePicker
  from '@/components/gabed/general/emplacementDispositifMaterielFacePicker';
import filtreEmplacement from '@/components/gabed/emplacement/filtreEmplacementDispoMaFace';
import { fillInfoOtPatrimoine } from '@/services/logistique/ordreTravail/tech/fillInfoOtPatrimoine';
import { getPageInitialSettings, getPageRecherche } from '@/services/gabed/emplacement/getPageSettings';

const EmplacementDispositifMaterielFace = createNamespacedHelpers('emplacementDispositifMaterielFacePicker');
const Societe = createNamespacedHelpers('societe');
const Intervention = createNamespacedHelpers('intervention');

export default {
  data() {
    return {
      showFiltre: false,
      emplacement: [],
      startArrayRendering: false,
      critereRecherche: genererCritereRechercheEmplacement(),
      demande: null,
    };
  },
  components: {
    breadcrumb,
    filtreEmplacement,
    emplacementDispositifMaterielFacePicker,
  },
  computed: {
    ...EmplacementDispositifMaterielFace.mapGetters({
      emplacements: 'items',
      total: 'total',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Intervention.mapGetters({
      demandeCourante: 'interventionCourant',
    }),
    getFilteredNumber() {
      const nbFiltre = calculNombreCritere(this.critereRecherche, ['auto', 'societeId', 'agencesId', 'actif']);
      if (nbFiltre > 9) return '9+';
      return nbFiltre;
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editionIntervention.breadcrumb.listeDemandeIntervention'), route: { name: 'l.logistique.demande_intervention' }, isActive: false },
        { title: this.$i18n.t('editionIntervention.breadcrumb.nouvelleIntervention'), route: { name: 'm.logistique.demande_intervention-add' }, isActive: false },
        { title: this.$i18n.t('editionIntervention.infoGenerale.addPatToDemande.breadcrumb.add'), route: '', isActive: true },
      ];
      if (this.demande && this.demande.id) {
        output[2].title = this.$i18n.t('editionIntervention.breadcrumb.edit');
        output[2].route = { name: 'm.logistique.demande_intervention-edition', params: { id: this.demande.id } };
      }
      return output;
    },
    getPageInitialSettings() {
      return getPageInitialSettings();
    },
    getPageRecherche() {
      return getPageRecherche();
    },
  },
  methods: {
    ...EmplacementDispositifMaterielFace.mapActions({
      actionLoadEmplacementDispositifMaterielFace: 'loadEmplacementDispositifMaterielFace',
    }),
    ...Intervention.mapActions({
      setInterventionCourant: 'setInterventionCourant',
    }),
    passToFalse(idPatrimoine) {
      this.emplacements.forEach((emplacement) => {
        if (idPatrimoine !== emplacement.id) emplacement.selected = false;
        emplacement.dispositifs.forEach((dispositif) => {
          if (idPatrimoine !== dispositif.id) dispositif.selected = false;
          dispositif.materiels.forEach((materiel) => {
            if (idPatrimoine !== materiel.id) materiel.selected = false;
            materiel.faces.forEach((face) => {
              if (idPatrimoine !== face.id) face.selected = false;
            });
          });
        });
      });
    },
    async closeFiltreAndMakeRecherche(critereRecherche) {
      this.showFiltre = !this.showFiltre;
      this.critereRecherche = critereRecherche;
      await this.loadEmplacement(this.getPageRecherche);
    },
    async selectPatrimoine() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const infoPatrimoine = {
          faceId: null, materielId: null, dispositifId: null, emplacementId: null,
        };
        this.emplacements.forEach((emplacement) => {
          if (emplacement.selected) infoPatrimoine.emplacementId = emplacement.id;
          emplacement.dispositifs.forEach((dispo) => {
            if (dispo.selected) {
              infoPatrimoine.emplacementId = null;
              infoPatrimoine.dispositifId = dispo.id;
            }
            dispo.materiels.forEach((mat) => {
              if (mat.selected) {
                infoPatrimoine.emplacementId = null;
                infoPatrimoine.dispositifId = null;
                infoPatrimoine.materielId = mat.id;
              }
              mat.faces.forEach((face) => {
                if (face.selected) {
                  infoPatrimoine.emplacementId = null;
                  infoPatrimoine.dispositifId = null;
                  infoPatrimoine.materielId = null;
                  infoPatrimoine.faceId = face.id;
                }
              });
            });
          });
        });
        await fillInfoOtPatrimoine(infoPatrimoine, false);
        this.demande.faceId = infoPatrimoine.faceId;
        this.demande.materielId = infoPatrimoine.materielId;
        this.demande.dispositifId = infoPatrimoine.dispositifId;
        this.demande.emplacementId = infoPatrimoine.emplacementId;
        this.demande.infoPatrimoine = infoPatrimoine;
        this.setInterventionCourant(this.demande);
        this.$router.go(-1);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    allMaterielSelected(dispositif) {
      return dispositif.materiels.length > 0
        && dispositif.materiels.length === dispositif.materiels
          .filter((materiel) => { return materiel.selected; }).length;
    },
    allDispositifSelected(emplacement) {
      return emplacement.dispositifs.length > 0
        && emplacement.dispositifs.length === emplacement.dispositifs
          .filter((dispositif) => { return dispositif.selected; }).length;
    },
    checkSelectedPatrimoine() {
      this.emplacements.forEach((emplacement) => {
        emplacement.dispositifs.forEach((dispositif) => {
          dispositif.materiels.forEach((materiel) => {
            if (this.demande.infoPatrimoine
              && materiel.id === this.demande.infoPatrimoine.materielId) {
              dispositif.selected = true;
              emplacement.selected = true;
              materiel.selected = true;
            }
          });
          dispositif.selected = this.allMaterielSelected(dispositif);
          if (this.demande.infoPatrimoine
            && dispositif.id === this.demande.infoPatrimoine.dispositifId) {
            dispositif.selected = true;
            emplacement.selected = true;
          }
        });
        emplacement.selected = this.allDispositifSelected(emplacement);
        if (this.demande.infoPatrimoine
          && emplacement.id === this.demande.infoPatrimoine.emplacementId) {
          emplacement.selected = true;
        }
      });
    },
    async loadEmplacement(page) {
      if (!this.demande) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche.societeId = this.demande.societeId || this.societeActiveId;
        await this.actionLoadEmplacementDispositifMaterielFace({
          query: this.critereRecherche,
          limit: page.limit,
          page: page.current,
          maxResultCount: page.limit,
        });
        this.checkSelectedPatrimoine();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!['m.logistique.demande_intervention-add', 'm.logistique.demande_intervention-edition'].includes(to.name)) {
      this.setInterventionCourant(null);
    }
    next();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.demande = cloneDeep(this.demandeCourante);
      if (!this.demande) {
        this.$router.go(-1);
        return;
      }
      this.critereRecherche.agencesId = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      await this.loadEmplacement(this.getPageInitialSettings);
      this.startArrayRendering = true;
      this.setInformationPage(this.$t('pageLogistique.demande.listeAjoutPatri'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      this.$router.go(-1);
      throw e;
    }
  },
};

</script>
